import axios from "axios"
import requestCache from "../requestCache"
const PACKURL={
    DEFAULT:"",
    BASE:"http://plc.deppon.com",//http://10.230.39.58:33526
    PLUGIN:""//http://10.230.39.59:33550
};
axios.interceptors.request.use(config => {
    //==========  所有请求之前都要执行的操作  ==============
    // `withCredentials` 表示跨域请求时是否需要使用凭证，默认false
    config.withCredentials=typeof config.withCredentials==='boolean'?config.withCredentials:true;
    if(config.useCache){
        const cache=requestCache.getItem(config.url);
        if(cache.isLoaded){
            throw cache
        }
    }
    let baseUrl="";
    const packageName=config.packageName;
    if(packageName){
        baseUrl=PACKURL[packageName]?PACKURL[packageName]:PACKURL.DEFAULT
    }
    config.url=baseUrl+config.url;
    return config;
}, err => {
    /*let unAlert=err.config?err.config.unAlert:false;
    if(!unAlert){
        Message.error('请求超时!');
    }*/
    return Promise.reject(err);
});
